var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "page-login__content" }, [
      _vm._v("Use the form below to sign in to your personal member area.")
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.login($event)
          }
        }
      },
      [
        _c("div", { staticClass: "row page-login__sign-in-row" }, [
          _c("div", { staticClass: "page-login__input col-md-6" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email"
                }
              ],
              staticClass:
                "page-login__login-input list-group-item form-control",
              attrs: { type: "text", placeholder: "email" },
              domProps: { value: _vm.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.email = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "page-login__input col-md-6" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password"
                }
              ],
              staticClass:
                "list-group-item form-control page-login__login-input",
              attrs: {
                type: "password",
                name: "password",
                placeholder: "password"
              },
              domProps: { value: _vm.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.password = $event.target.value
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row text-center" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "button",
              {
                staticClass: "page-login__login-btn",
                attrs: { type: "submit", disabled: !_vm.isFormValid }
              },
              [_vm._v("Sign in")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row text-center" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "a",
              {
                staticClass: "page-login__trouble-link",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.toReset($event)
                  }
                }
              },
              [_vm._v("Trouble signing in?")]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }